import { Form, Select, Spin } from "antd";
// import { App } from "@lhd/types";
import { useMemo, useRef, useState } from "react";
import { useFetchApps } from "@lhd/hooks";
import debounce from "lodash/debounce";

const AppSelect = () => {
  const fetchRef = useRef(0);
  const [
    page,
    // setPage,
  ] = useState(1);
  const [filterParams, setFilter] = useState({});
  const {
    data: appData,
    // isLoading,
    isFetching,
    // isSuccess,
  } = useFetchApps(page, 20, filterParams);

  const debounceFetcher = useMemo(() => {
    const loadOptions = (name_cont: string) => {
      fetchRef.current += 1;
      setFilter({ q: { name_cont } });
    };

    return debounce(loadOptions, 500);
  }, [setFilter]);

  const options = useMemo(() => {
    return (appData?.data || []).map((app) => ({
      label: app.name,
      value: app.id,
    }));
  }, [appData]);

  return (
    <Form.Item
      extra={<div>設定後にデータソースが変更できない</div>}
      label="データソース Bizシート"
      rules={[{ required: true }]}
    >
      <Select
        style={{ width: 300 }}
        onClear={() => setFilter({})}
        allowClear
        showSearch
        filterOption={false}
        options={options}
        onSearch={debounceFetcher}
        notFoundContent={isFetching ? <Spin size="small" /> : null}
      />
    </Form.Item>
  );
};
export default AppSelect;
